import { OneColorIconProps, getHexColor } from '@/atoms/utils'

export function MenuIcon(props: OneColorIconProps) {
  const color = getHexColor(props.color || 'white')
  const size = props.size || 24
  const className = props.className
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 20C3.71667 20 3.47933 19.904 3.288 19.712C3.096 19.5207 3 19.2833 3 19C3 18.7167 3.096 18.4793 3.288 18.288C3.47933 18.096 3.71667 18 4 18H20C20.2833 18 20.5207 18.096 20.712 18.288C20.904 18.4793 21 18.7167 21 19C21 19.2833 20.904 19.5207 20.712 19.712C20.5207 19.904 20.2833 20 20 20H4ZM4 13C3.71667 13 3.47933 12.904 3.288 12.712C3.096 12.5207 3 12.2833 3 12C3 11.7167 3.096 11.479 3.288 11.287C3.47933 11.0957 3.71667 11 4 11H20C20.2833 11 20.5207 11.0957 20.712 11.287C20.904 11.479 21 11.7167 21 12C21 12.2833 20.904 12.5207 20.712 12.712C20.5207 12.904 20.2833 13 20 13H4ZM4 6C3.71667 6 3.47933 5.90433 3.288 5.713C3.096 5.521 3 5.28333 3 5C3 4.71667 3.096 4.479 3.288 4.287C3.47933 4.09567 3.71667 4 4 4H20C20.2833 4 20.5207 4.09567 20.712 4.287C20.904 4.479 21 4.71667 21 5C21 5.28333 20.904 5.521 20.712 5.713C20.5207 5.90433 20.2833 6 20 6H4Z"
        fill={color}
      />
    </svg>
  )
}
